import type { FirstTaskRewardAction, FirstTaskRewardAgentType } from './first-task-reward-api';

/** 报告页奖励引导配置。 */
export interface FirstTaskRewardReportOptions {
    /** 当前报告任务 ID。 */
    taskId: string;
    /** 当前 Agent。 */
    agentType: FirstTaskRewardAgentType;
    /** 报告正文稳定选择器。 */
    reportSelector: string;
    /** 页面原有分享入口稳定选择器。 */
    shareSelector: string;
    /** 页面原有导出入口稳定选择器。 */
    exportSelector: string;
}

/** 首次任务奖励业务服务。 */
export interface FirstTaskRewardService {
    /** 在真实报告完成后保存领取上下文，并在页面目标挂载后展示权益卡片。 */
    startReport(options: FirstTaskRewardReportOptions): void;
    /** 销毁当前报告页领取上下文和权益卡片。 */
    destroyReport(): void;
    /** 报告原有动作在真实成功边界完成后通知领取。 */
    notifyActionSucceeded(action: FirstTaskRewardAction): void;
    /** 分享弹窗关闭或动作失败时取消对应的弹窗交互状态。 */
    cancelPendingAction(action?: FirstTaskRewardAction): void;
}

export const FirstTaskRewardService = Symbol('FirstTaskRewardService');
